import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('RegistrationScheme', RegistrationSchemeData);

    RegistrationSchemeData.$inject = ['$translate'];

    /* @ngInject */
    function RegistrationSchemeData($translate) {
        RegistrationScheme.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getCountryLabel: getCountryLabel,
            getLabel: getLabel,
            getScope: getScope
        };

        function RegistrationScheme(registrationSchemeData) {
            if (!registrationSchemeData) {
                this.buildEmpty();
            } else {
                this.build(registrationSchemeData);
            }
        }

        return RegistrationScheme;

        /////////////////////

        function buildEmpty() {
            this.code = null;
            this.countryCode = null;
            this.scope = null;
            this.format = null;
        }

        function build(registrationSchemeData) {
            this.code = angular.lowercase(registrationSchemeData.code) || null;
            this.countryCode = angular.lowercase(registrationSchemeData.countryCode) || null;
            this.scope = angular.lowercase(registrationSchemeData.scope) || null;
            this.format = angular.lowercase(registrationSchemeData.format) || null;
        }

        function getCountryLabel() {
            if (this.countryCode) {
                return $translate.instant('country.' + angular.lowercase(this.countryCode));
            }
            return '';
        }

        function getLabel() {
            if (this.code) {
                return $translate.instant('identifiant.type.' + angular.lowercase(this.code));
            }
            return '';
        }

        function getScope() {
            if (this.scope) {
                return angular.lowercase(this.scope);
            }
            return null;
        }
    }
})();
